export default "__VITE_ASSET__CPzZLgtd__"